exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tencent-info{height:100%}.yxtbiz-doc-viewer--tencent,.yxtbiz-doc-viewer--tencent iframe{height:100%;overflow:auto;overscroll-behavior:contain}.web-office-default-container{display:none}\n", ""]);

